import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAdminPassword } from '../utils/api';

export default function LoginPage() {
  const [pw, setPw] = useState('');
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    if (!pw.trim()) return;
    setAdminPassword(pw.trim());
    navigate('/products');
  }

  return (
    <>
      <style>{css}</style>
      <div className="login-page">
        <div className="login-card">
          <h1 className="login-title">Hockey Sticks Admin</h1>
          <p className="login-subtitle">Sign in to manage products</p>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="Admin password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="login-input"
              autoFocus
            />
            <button type="submit" className="login-button">Sign in</button>
          </form>
        </div>
      </div>
    </>
  );
}

const css = `
  .login-page {
    min-height: 100vh;
    width: 100%;
    background: #F5F5F7;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    padding: 20px;
    box-sizing: border-box;
  }
  .login-card {
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 2px 20px rgba(0,0,0,0.06);
    padding: 40px;
    width: 100%;
    max-width: 400px;
    box-sizing: border-box;
  }
  .login-title {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1d1d1f;
  }
  .login-subtitle {
    margin: 8px 0 24px 0;
    color: #86868b;
    font-size: 15px;
  }
  .login-input {
    width: 100%;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid #d2d2d7;
    font-size: 16px;
    box-sizing: border-box;
    margin-bottom: 12px;
    outline: none;
    font-family: inherit;
  }
  .login-button {
    width: 100%;
    padding: 12px 16px;
    border-radius: 12px;
    border: none;
    background: #0071e3;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
  }
  @media (max-width: 600px) {
    .login-card { padding: 28px 20px; }
    .login-title { font-size: 22px; }
  }
`;
